import type {
  CartExperimentParseResult,
  CartExperimentPolicy,
  CartExperimentState,
  CartExperimentValue,
} from './types';

export type {
  CartCouponPolicy,
  CartExperience,
  CartExperimentFallbackReason,
  CartExperimentParseResult,
  CartExperimentPolicy,
  CartExperimentSource,
  CartExperimentState,
  CartExperimentValue,
} from './types';

/** 仅解析原始策略值；不做 Number/trim 等隐式宽松转换，也不替调用方降级。 */
export function parseCartExperimentValue(raw: unknown): CartExperimentParseResult {
  switch (raw) {
    case 1:
    case '1':
      return { status: 'valid', value: 1 };
    case 2:
    case '2':
      return { status: 'valid', value: 2 };
    case 3:
    case '3':
      return { status: 'valid', value: 3 };
    case 4:
    case '4':
      return { status: 'valid', value: 4 };
    default:
      return { status: 'invalid' };
  }
}

/** 非法调用直接报错，既保证穷尽检查，也避免运行时绕过类型后误分组。 */
function rejectInvalidCartExperimentValue(_value: never): never {
  throw new RangeError('Invalid cart experiment value');
}

/** 只接受已解析的数字组号；每次返回独立对象，不维护第二份可变策略状态。 */
export function getCartExperimentPolicy(value: CartExperimentValue): CartExperimentPolicy {
  switch (value) {
    case 1:
      return { experience: 'legacy', couponPolicy: 'manual' };
    case 2:
      return { experience: 'legacy', couponPolicy: 'automatic' };
    case 3:
      return { experience: 'v1', couponPolicy: 'manual' };
    case 4:
      return { experience: 'v1', couponPolicy: 'automatic' };
    default:
      return rejectInvalidCartExperimentValue(value);
  }
}

/**
 * 页面、WAP 导航和 MiniCart 共用站点策略：小语种固定为新版 + 手动用券（等同第 3 组策略），
 * 不依赖实验状态，也不将固定配置伪造成真实分桶。US 仍按接口四组结果及原降级策略执行。
 */
export function getCartSitePolicy(
  site: string,
  experiment: CartExperimentState,
): CartExperimentPolicy {
  if (site !== 'us') return getCartExperimentPolicy(3);
  return getCartExperimentPolicy(experiment.status === 'resolved' ? experiment.value : 1);
}
